export default __webpack_public_path__ + "assets/shuwen-tech-white.2090f8b1.png";